module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.editSupplement ? 'Rediger tillæg' : 'Opret tillæg'))]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "do-form-row"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Vælg ansat")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userId),
      expression: "userId"
    }],
    staticClass: "height-34 do-select width-100",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onUserChange($event.target.value)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Vælg ansat")]), _vm._v(" "), _vm._l((_vm.usersSortedOnName), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n              " + _vm._s(user.name) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Brutto årsnorm")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.yearNormHours),
      expression: "yearNormHours"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.yearNormHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.yearNormHours = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.isCodeLocked) ? _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Lønkode")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salaryCodeId),
      expression: "salaryCodeId"
    }],
    staticClass: "height-34 do-select width-100",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.salaryCodeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode) {
    return _c('option', {
      key: salaryCode.id,
      domProps: {
        "value": salaryCode.id
      }
    }, [_vm._v("\n              " + _vm._s(salaryCode.vSupplementTitle) + "\n            ")])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Omkostningssted")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.costCenterId),
      expression: "costCenterId"
    }],
    staticClass: "height-34 do-select width-100",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.costCenterId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.costCenters), function(costCenter) {
    return _c('option', {
      key: costCenter.id,
      domProps: {
        "value": costCenter.id
      }
    }, [_vm._v("\n              " + _vm._s(_vm.costCenterLabel(costCenter)) + "\n            ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "do-form-row"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Startdato")]), _vm._v(" "), _c('DateSelector', {
    staticClass: "width-100",
    attrs: {
      "date": _vm.startDate,
      "width100": true
    },
    on: {
      "changed": function (val) { return _vm.startDate = val; }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Slutdato")]), _vm._v(" "), _c('DateSelector', {
    attrs: {
      "date": _vm.endDate,
      "width100": true
    },
    on: {
      "changed": function (val) { return _vm.endDate = val; }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Enheder i periode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.units),
      expression: "units"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "inputmode": "decimal"
    },
    domProps: {
      "value": (_vm.units)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.units = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Antal udbetalinger")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installments),
      expression: "installments"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.installments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.installments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Enheder pr. måned")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unitsPerInstallment),
      expression: "unitsPerInstallment"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "inputmode": "decimal"
    },
    domProps: {
      "value": (_vm.unitsPerInstallment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.unitsPerInstallment = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', {
    staticClass: "d-modal__buttons__left"
  }, [(_vm.editSupplement) ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isConfirmDelete = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons__right"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    attrs: {
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.editSupplement ? 'Opdater' : 'Opret') + "\n        ")])])]), _vm._v(" "), (_vm.isConfirmDelete) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false
    },
    on: {
      "close": function($event) {
        _vm.isConfirmDelete = false
      },
      "confirm": function($event) {
        return _vm.$emit('delete', _vm.editSupplement.id)
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cc10cc3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplements/CreateSupplement.vue
// module id = 2126
// module chunks = 1